import type { ExperimentConfig } from '../@types'

// Launches on a country = US audience.
const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_microdrama_story~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_microdrama_story/__b_f'
					),
			},
		},
		// Variant B changes only the loader (see ProgressTeaser). The key must still exist here:
		// getAppAreaExperiment logs an error when an appArea is missing from one variant object.
		'activity-male-chair-tai-chi': {},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_microdrama_story~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_microdrama_story/__c_f'
					),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_tai_chi_microdrama_story~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_microdrama_story/__c_m'
					),
			},
		},
	},
]

export default config
